class CustomSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-slider-viewport]');
    this.track = this.querySelector('[data-slider-track]');
    this.prevButton = this.querySelector('[data-slider-prev]');
    this.nextButton = this.querySelector('[data-slider-next]');

    if (!this.viewport || !this.track || !this.prevButton || !this.nextButton) {
      return;
    }

    this.prevButton.addEventListener('click', () => this.slide('prev'));
    this.nextButton.addEventListener('click', () => this.slide('next'));

    this.viewport.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons());

    this.updateButtons();
  }

  slide(direction) {
    const card = this.querySelector('[data-slider-item]');
    if (!card) return;

    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const amount = card.getBoundingClientRect().width + gap;

    this.viewport.scrollBy({
      left: direction === 'next' ? amount : -amount,
      behavior: 'smooth'
    });
  }

  updateButtons() {
    const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
    const currentScroll = this.viewport.scrollLeft;

    this.prevButton.disabled = currentScroll <= 5;
    this.nextButton.disabled = currentScroll >= maxScroll - 5;
  }
}

if (!customElements.get('custom-slider')) {
  customElements.define('custom-slider', CustomSlider);
}